module.exports = __webpack_public_path__ + "static/media/menu-your-finances.fb054cb2.svg";